/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_3_DescInputs */

const en_mk_sec_3_desc = /** @type {(inputs: Mk_Sec_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`config.json holds ids only and is safe to commit; pending, summaries and state are git-ignored automatically.`)
};

const id_mk_sec_3_desc = /** @type {(inputs: Mk_Sec_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`config.json hanya berisi id dan aman di-commit; pending, summaries, dan state otomatis masuk .gitignore.`)
};

/**
* | output |
* | --- |
* | "config.json holds ids only and is safe to commit; pending, summaries and state are git-ignored automatically." |
*
* @param {Mk_Sec_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_3_desc = /** @type {((inputs?: Mk_Sec_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_3_desc(inputs)
	return en_mk_sec_3_desc(inputs)
});